import { useState } from "react"
import { Outlet } from "react-router-dom"
import Sidebar from "./Sidebar/Sidebar"

export default function Layout() {
  const [isOpen, setIsOpen] = useState<boolean>(true)
  const toggle = () => setIsOpen(!isOpen)

  const styles = {
    paddingLeft: `calc(${isOpen ? 200 : 50}px + .5rem)`,
    paddingRight: ".5rem",
  }

  return (
    <>
      <Sidebar toggle={toggle} isOpen={isOpen} />
      <div style={styles}>
        <Outlet />
      </div>
    </>
  )
}
